/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Add_RowInputs */

const vi_common_add_row = /** @type {(inputs: Common_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm dòng`)
};

/**

* @param {Common_Add_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_add_row = /** @type {((inputs?: Common_Add_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Add_RowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_add_row(inputs)
});